export default __webpack_public_path__ + "static/media/paypal-marked.dcc73150.png";